<template>
    <div>
        <Modal v-model="$parent.contractorListDialog" :mask-closable="false" width="550">
            <div slot="header"><strong>Contractor ({{contractorArr.length}})</strong>
                <Icon type="md-add-circle" style="float: right" size="22" @click="onAddContractor()"></Icon>
            </div>
            <div>
                <Table :columns="contractorHeaders" :data="contractorArr" size="small" max-height="400" v-if="$parent.contractorListDialog">
                    <template slot-scope="{ row }" slot="action">
                        <Icon type="md-create" @click="onEditContractor(row)"></Icon>&nbsp;
                        <Icon type="md-close" @click="onDeleteContractor(row.id)"></Icon>
                    </template>
                </Table>
            </div>
            <div slot="footer">
                <Button style="background: #999999; color: white;font-weight: bolder" @click="$parent.contractorListDialog=false">CLOSE</Button>
            </div>
        </Modal>

      <add-contractor ref="contractor-form"></add-contractor>

    </div>
</template>

<script>
    import {ADD_CONTRACTOR, UPDATE_CONTRACTOR, DELETE_CONTRACTOR} from '../../graphql/mutations/vehicle'
    import { GET_CONTRACTORS, GET_LAST_CONTRACTOR} from '../../graphql/queries/vehicle'
    import { SUBSCRIBE_CONTRACTORS} from '../../graphql/subscription/vehicle'
    import AddContractor from "../ExcelContractors/AddContractor";
    export default {
      components: {AddContractor},
      apollo: {
            contractor: {
                query: GET_CONTRACTORS,
                subscribeToMore: {
                    document: SUBSCRIBE_CONTRACTORS,
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.contractorArr = subscriptionData.data.contractor;
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.contractorArr = data.contractor;
                    }
                }
            },
        },
        name: "Contractor",
        data: function(){
            return{
                mutation_ADD_CONTRACTOR: ADD_CONTRACTOR,
                mutation_UPDATE_CONTRACTOR: UPDATE_CONTRACTOR,
                mutation_DELETE_CONTRACTOR: DELETE_CONTRACTOR,
                query_GET_LAST_CONTRACTOR: GET_LAST_CONTRACTOR,
                contractorArr: [],
                contractorHeaders: [
                    {title: 'Name', key: 'name'},
                    {title: 'Code', key: 'contractorCode'},
                    {title: 'mobile', key: 'mobile'},
                    {title: 'email', key: 'email'},
                    {title: 'Monthly KM', key: 'monthlyKms'},
                    {title: ' ', slot: 'action', width: 60}
                ],
                loading: false
            }
        },
        methods:{
            onAddContractor(){
              this.$refs['contractor-form'].onAddContractor();
            },
            onEditContractor(row){
              this.$refs['contractor-form'].onEditContractor(row);
            },
            onDeleteContractor(contractorId){
                this.$Modal.confirm({
                    title: 'Confirmation',
                    content: '<p>Are You sure want to delete Contractor ?</p>',
                    loading: true,
                    onOk: () => {
                        this.deleteContractor(contractorId, this.$Modal)
                    }
                });
            },
            deleteContractor(contractorId, callback){
                this.$apollo.mutate({
                    mutation: this.mutation_DELETE_CONTRACTOR,
                    variables: { contractorId: contractorId }
                }).then(function(response){
                    callback.remove();
                    this.$Message.success('Contractor deleted successfully!');
                }).catch(function(err){
                    callback.remove();
                })
            }
        },

    }
</script>

<style scoped>
    /deep/ .ivu-modal-close{
        visibility: hidden;
    }
    /deep/ .code-uppercase > input{
        text-transform: uppercase;
    }
    /deep/ .ivu-table td {
        border-bottom: 0px;
        font-size: 14px;
    }
    /deep/ .ivu-table th {
        border-bottom: 0px;
        font-size: 14px;
        text-align: center;
    }
    /deep/ .ivu-table-wrapper {
        position: unset !important;
        border: 0px ;
    }
    /deep/ .ivu-table-cell {
        padding-left: 0px;
        padding-right: 0px;
        text-align: center;
    }
    /deep/ .capitalize-gstin input{
        text-transform: uppercase;
    }
</style>
